import { preventAutoHideAsync } from 'expo-splash-screen';

preventAutoHideAsync().catch(() => {});
